import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import PubSub from 'pubsub-js'
import formatNumber from '@arsenal/arsenal/modules/formatNumber'
import useToggleFollow from 'Components/hooks/use-toggle-follow'

const EVETN_NAME = 'AUTHOR_FOLLOW_BTN'

interface IFansNumsProps {
  nums: number
  style?: React.CSSProperties
}

export function FansNums({ nums, style = {} }: IFansNumsProps) {
  const [count, setCount] = useState<number>(nums)

  useEffect(() => {
    const token = PubSub.subscribe(EVETN_NAME, (type: any, value: boolean) => {
      if (value) {
        setCount((c) => c + 1)
      } else {
        setCount((c) => c - 1)
      }
    })

    return () => {
      PubSub.unsubscribe(token)
    }
  }, [])

  useEffect(() => {
    setCount(nums)
  }, [nums])

  return <span style={style}>{formatNumber(count)}</span>
}

interface IProps {
  authorId: string
  isFollow: boolean
  style?: React.CSSProperties
}

export default function FollowBtn({ authorId, style = {}, isFollow }: IProps) {
  const { update, curStatus } = useToggleFollow({
    userId: authorId,
    followed: isFollow,
  })

  return (
    <button
      type={'button'}
      onClick={update}
      className={classNames('btn', {
        follow: curStatus,
      })}
      style={style}
    >
      {curStatus ? '已关注' : '关注'}
      <style jsx>
        {`
          .btn {
            display: inline-block;
            height: 36px;
            padding: 8px 16px;
            border-radius: 4px;
            background-color: #ffcc32;
            font-size: 14px;
            font-weight: 500;
            color: #1f2129;
            outline: none;
          }
          .btn.follow {
            background-color: rgba(0, 0, 0, 0.06);
            color: rgba(0, 0, 0, 0.32);
            cursor: auto;
          }
        `}
      </style>
    </button>
  )
}
